// Approved DECO gameplay exports, inventoried against their Studio sources and public bytes.
// Source and preview fingerprints identify the reviewed exports; no binary assets are bundled.
export const CATALOG_V1_GAMEPLAY_MEDIA = {
    'united-square-original': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '11c67c19f8ba1e3afdd473119d0fdbd1660ff713b081178f28149fad39ba496f',
            fingerprint: {
                byteSize: 193751,
                sha256: '9c24d06932259f643eb929de50065ddd534114cfede689bc27f05a70c6654c6a',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '11c67c19f8ba1e3afdd473119d0fdbd1660ff713b081178f28149fad39ba496f',
            fingerprint: {
                byteSize: 1694866,
                sha256: '0bb00860fe492110cd563e58e85ed15151f0290ec212cc74a883843ed3e58b3a',
            },
        },
    ],
    'art-01-la-vague': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '6a2bd34c8ffe8fd85962bd1a2e5b6b8ced1452d18a00fa8ad998c6acbe61a325',
            fingerprint: {
                byteSize: 187353,
                sha256: '7e6a0be8132b4f909dfaadc3fb333e83ae93ce3cbd32a71fac5306116c15d7ae',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '6a2bd34c8ffe8fd85962bd1a2e5b6b8ced1452d18a00fa8ad998c6acbe61a325',
            fingerprint: {
                byteSize: 1684545,
                sha256: 'da22c609db4c04585091dfc4a9b692b1bc532155d195a3ef0dae951b888cb887',
            },
        },
    ],
    'art-02-le-baiser': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '5250adae954e174f3742f5c89c51a6e230ce23e90f4c83f11e540d3e65b40021',
            fingerprint: {
                byteSize: 201201,
                sha256: '884856e93d0f41974135268c7b84ec1a57518fde226fc301711a649cb7923463',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '5250adae954e174f3742f5c89c51a6e230ce23e90f4c83f11e540d3e65b40021',
            fingerprint: {
                byteSize: 1690890,
                sha256: '84b3ee8f9b77b8233a1fc7732f2371fa34d49fcaf794edcff9cea8eb48ac13c7',
            },
        },
    ],
    'art-03-la-nuit-etoilee': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '921fec31082f1d3ce5c49270d5cd8d36ba8775ef74ca92d87af4b63129bf81e9',
            fingerprint: {
                byteSize: 203453,
                sha256: '1cfdf9dfdf7cab14a95a1c38bdcc9dc71fafe97fcf90d660025707b77ef23f61',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '921fec31082f1d3ce5c49270d5cd8d36ba8775ef74ca92d87af4b63129bf81e9',
            fingerprint: {
                byteSize: 1689626,
                sha256: 'f6460df16448f0d788e416b0d23ee01ad1912c48101117d0591710f2ee59271f',
            },
        },
    ],
    'birdie-01-bistrot': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '8362258f8fd92c07e2a831e10ac86bb33fb9b3faa36c51bffa199573e8b104a6',
            fingerprint: {
                byteSize: 198889,
                sha256: '96549ba8e42ed09352211153b0e113d394e57c9c8ce95e1e32393766a54a81b1',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '8362258f8fd92c07e2a831e10ac86bb33fb9b3faa36c51bffa199573e8b104a6',
            fingerprint: {
                byteSize: 1689463,
                sha256: 'e11870884da669ae71528efbc5748c400432a1ac518b9848c130857339e52383',
            },
        },
    ],
    'birdie-02-boulangerie': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '9694c64ccfc0dfd17e01dea38540e918c41ac0dd3e1ed045b5a564fa026fb329',
            fingerprint: {
                byteSize: 197657,
                sha256: 'f5ff6f0747153cfa0f2deee84e83978f59468a0da52d824677985a9327d5f89c',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '9694c64ccfc0dfd17e01dea38540e918c41ac0dd3e1ed045b5a564fa026fb329',
            fingerprint: {
                byteSize: 1683862,
                sha256: '412ae1b0869ef6bf496d444995214b606f2eab32e4982ab6833e7a7d893130ff',
            },
        },
    ],
    'birdie-03-fromagerie': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'e6576399771ed6887c0b313aa9a307357c56c8390ea47696ba4fd2831a72cf47',
            fingerprint: {
                byteSize: 196728,
                sha256: 'd86ff3a9fa7a32a057bd8154fd49310245c6a483275e014aede19b300995ce08',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'e6576399771ed6887c0b313aa9a307357c56c8390ea47696ba4fd2831a72cf47',
            fingerprint: {
                byteSize: 1688251,
                sha256: '64dfa3f6882003a6c1d968d9fe2de65428e29cc0d5bb2d57fde1fbd67763aeaf',
            },
        },
    ],
    'birdie-04-les-toits': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'fe55fe78ba9a222edf20a44726680475d58e3fc7126c6a267c67b6fed80a1436',
            fingerprint: {
                byteSize: 195435,
                sha256: 'd838720d5399c9ae32f3f52f081ef007a42553dfb7b380d10f084a2629269167',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'fe55fe78ba9a222edf20a44726680475d58e3fc7126c6a267c67b6fed80a1436',
            fingerprint: {
                byteSize: 1683624,
                sha256: '29a92be028f121a1079c39897a67c5b2b2302a59a7241d5aaf4a650e63514306',
            },
        },
    ],
    'birdie-05-patisserie': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '09c33e0f63585a1ce92647e11a9c4b9d04444084883fefb2dd8fb8c3dc1c771f',
            fingerprint: {
                byteSize: 197788,
                sha256: '4eaeb83fb29baf4f7d913184b590ec5abeefb9f402343bd8e472f3b2ea8edb85',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '09c33e0f63585a1ce92647e11a9c4b9d04444084883fefb2dd8fb8c3dc1c771f',
            fingerprint: {
                byteSize: 1683147,
                sha256: 'c023a013f1548d39d899730812ca3f281ae0f693db35e8002ed5c4a5c1c9ac2b',
            },
        },
    ],
    'le-petit-prince-01-la-rose': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'ca240310aeb4e86280f677a99d0236304ba09f0e4c5ad966484a3718f0bcefb0',
            fingerprint: {
                byteSize: 192836,
                sha256: '55cc8b27b58f47699dd2e94112c4fbcdcf720e7069181cf7c85695cd89448b0a',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'ca240310aeb4e86280f677a99d0236304ba09f0e4c5ad966484a3718f0bcefb0',
            fingerprint: {
                byteSize: 1689982,
                sha256: 'cbd5d27a439a0eae75f21ec536986f189d431ff6606cdb8df812546024fb9625',
            },
        },
    ],
    'le-petit-prince-02-la-boite': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'dabea0292a8e7d40ff2afb0b0ad32f90112d7f2eb3135b4bb1875a4f68ee5907',
            fingerprint: {
                byteSize: 189965,
                sha256: '91d085fea006966f23735d155eb61253f12a0479dd2c3248d0228e474b148ee9',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'dabea0292a8e7d40ff2afb0b0ad32f90112d7f2eb3135b4bb1875a4f68ee5907',
            fingerprint: {
                byteSize: 1689311,
                sha256: '5362c12edbca2111d6077571d5c2ad6d5c3cbc09df1da77bf599a141f42f4762',
            },
        },
    ],
    'le-petit-prince-03-best-friends': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '4e441e96f5d46b42ceef74c5f391248ec2275ca254cbd1ae4d148379cf6ae3b7',
            fingerprint: {
                byteSize: 192470,
                sha256: '50b53af77380bfacb0c5b44f57fdcbde5fa85650b7f4de6875d48feceb9f5671',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '4e441e96f5d46b42ceef74c5f391248ec2275ca254cbd1ae4d148379cf6ae3b7',
            fingerprint: {
                byteSize: 1691719,
                sha256: '5c6aa053764708e10954244c6bb9dbcba0f01412c04319393ec787d24f9890c6',
            },
        },
    ],
    'le-petit-prince-04-look-with-the-heart': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '5935cc32c9b934f60b8fd4fb700ccf0d3b531131a9c22577fefd842e385c2a0f',
            fingerprint: {
                byteSize: 187204,
                sha256: '60672db20b57668ff07ab13fc0313729475e3fb62d6e1a20cc7748f40eb7728b',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '5935cc32c9b934f60b8fd4fb700ccf0d3b531131a9c22577fefd842e385c2a0f',
            fingerprint: {
                byteSize: 1682725,
                sha256: 'b91f2cd42cd9155a6070ae83fd7a58eab4b8bda0dd4b71ac836a7c7f81c24ac4',
            },
        },
    ],
    'le-petit-prince-05-vois-avec-le-coeur': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '4580106ff9266141802361c10a45fb9d9b7614061c9c35f6b4618681a59274ea',
            fingerprint: {
                byteSize: 187108,
                sha256: '4214a73b052da72e3e8109a73bb8daebe0b7814df4e1e6dfcc9292172b9ba4cd',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '4580106ff9266141802361c10a45fb9d9b7614061c9c35f6b4618681a59274ea',
            fingerprint: {
                byteSize: 1682725,
                sha256: 'b91f2cd42cd9155a6070ae83fd7a58eab4b8bda0dd4b71ac836a7c7f81c24ac4',
            },
        },
    ],
    'samy-halim-01-keli': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'dfb605324848f3ea9829b4754d3bd9c86512c07adb121dd99351d26a85fb1ac7',
            fingerprint: {
                byteSize: 194754,
                sha256: 'a669816bc681e813253a6c3ec5b7d3b34226a882ad3c254f30965e6445f33d84',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'dfb605324848f3ea9829b4754d3bd9c86512c07adb121dd99351d26a85fb1ac7',
            fingerprint: {
                byteSize: 1691159,
                sha256: '6f134e2583d8bc74e7b1bef94ba284ef7e880c8c2ec910dd74ba7b7d4dbc1846',
            },
        },
    ],
    'samy-halim-02-kenza': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'd623d6659b21268ff788aac983213e6816a5002d4feaeef85b913d5a33e14fa5',
            fingerprint: {
                byteSize: 195032,
                sha256: '21dac04dc97f4fd1bd8f1fafee2cc6c659eda2757ae133c8aec92555b3010095',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'd623d6659b21268ff788aac983213e6816a5002d4feaeef85b913d5a33e14fa5',
            fingerprint: {
                byteSize: 1686450,
                sha256: '0c09e51b457e499005b9c2f8b24bde03d667535bc27ab046bd39e84417e34170',
            },
        },
    ],
    'samy-halim-03-victoria': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'c591479aff022c2eefe640715b5461df5419b91c3ae478962e30015590a940e3',
            fingerprint: {
                byteSize: 193503,
                sha256: 'e921e677a990c8ceb094e9f2172845a785510817aa1daa58a0276955d57f6567',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'c591479aff022c2eefe640715b5461df5419b91c3ae478962e30015590a940e3',
            fingerprint: {
                byteSize: 1688522,
                sha256: '73b523370599708cbb868788c88c0ae4537e53046c1af179d69a12345f3cfd44',
            },
        },
    ],
    'crazy-new-york-01': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '2f13c6bc69c47bcba653c50680e42de9be8dd383cf0d22c9e2de2fe57a1d6ecb',
            fingerprint: {
                byteSize: 207250,
                sha256: 'a6751fae1013574da279c26ec0bcf41a18b7823d9e5017c9b7790a9228a0b14d',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: '2f13c6bc69c47bcba653c50680e42de9be8dd383cf0d22c9e2de2fe57a1d6ecb',
            fingerprint: {
                byteSize: 1691949,
                sha256: '5b75d9641f7396065a78d08cf801517f21a61d1b09d3ba7186258ff9cde6f040',
            },
        },
    ],
    'pop-art-01': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'd5cada59fda9e1da092e84549a05ae1c378482a923a5afd3d6d71a25da71ac1f',
            fingerprint: {
                byteSize: 204604,
                sha256: '601f3633d9c6a1f44a17d751e119d5e375dcff78317b41bccbf2bb314e991bd3',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'd5cada59fda9e1da092e84549a05ae1c378482a923a5afd3d6d71a25da71ac1f',
            fingerprint: {
                byteSize: 1689783,
                sha256: '38f74eb575dfb74a5133615eed2359457438538c637c07f22811b643fd38600a',
            },
        },
    ],
    'le-mur-des-je-t-aime-01': [
        {
            assetPath: 'preview-puzzle-poster.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'eb616fccfb71d2d3529844e7b3d8de82510a9d16e047ec9de6bcf57244461303',
            fingerprint: {
                byteSize: 207632,
                sha256: '7e886de97960b21c1c1b879a23f10df1e5ac86deab72209834fd45bdbc0dbca0',
            },
        },
        {
            assetPath: 'preview-poster-play-family.png',
            sourceAssetPath: 'poster-source.png',
            sourceSha256: 'eb616fccfb71d2d3529844e7b3d8de82510a9d16e047ec9de6bcf57244461303',
            fingerprint: {
                byteSize: 1690775,
                sha256: '516225162d5ced2dbd70356eb8d577a5c1cf686c211d7dc1d28e793e7c950389',
            },
        },
    ],
};
